export default "__VITE_ASSET__FlK8R4Nm__"